import { isArray, isObject } from "lodash";

export const resultToReportConfig = (
  result = {},
  { compare = false, limit = 5 } = {}
) => {
  if (!result) {
    return null;
  }

  const { dimensions = [], measures = [], filters = [] } = result;

  return {
    name: "Custom View",
    template: "custom",
    chartType: toChartType(result),
    config: {
      dataSet: "SaleItem",
      dataType: toDataType(result),
      dimensions: dimensions,
      measures: measures,
      filters:
        filters && isArray(filters)
          ? filters.map((f) => ({
              member: f.dimension,
              operator: "contains",
              values: f.values,
            }))
          : [],
      sort: formatSort(result),
      compare,
      limit,
      colorTheme: "default",
      timeDimension: toTimeDiemension(result),
      hideLegend: true,
      applyDateRangeFilter: toApplyDateRangeFilter(result),
    },
  };
};

export const toTimeDiemension = (result) => {
  if (result.timeDimensions) {
    return result.timeDimensions[0]?.dimension;
  }
};

export const isTimeSeries = (report) => {
  const timeSeries = report.timeDimensions;
  return timeSeries?.length && timeSeries[0]?.granularity ? true : false;
};

export const toDataType = (result) => {
  const t = isTimeSeries(result);
  return t ? "time_series" : "single";
};

export const toApplyDateRangeFilter = (result) => {
  if (!result.timeDimensions) {
    return true;
  }
  return false;
};

export const toChartType = (result) => {
  if (result.dimensions || result.timeDimensions) {
    const t = isTimeSeries(result);
    return t ? "LINE" : result?.dimensions?.length ? "COLUMN" : "NUMBER";
  }
  return "NUMBER";
};

export const formatSort = (result) => {
  if (result.order) {
    return {
      by: Object.keys(result.order)[0],
      direction: result.order[Object.keys(result.order)[0]],
    };
  }
};

// Attempt to fix any common issues with the ai created query
export function normalizedQuery(query) {
  let normalizedFilters = [];

  if (query.filters) {
    if (isArray(query.filters)) {
      normalizedFilters = query.filters.map((f) => {
        return {
          ...f,
          dimension: replaceDimensionMiss(f.dimension),
          operator: "contains",
          values: f.values,
        };
      });
    } else if (isObject(query.filters)) {
      // this ai will sometimes return an object instead of an array
      normalizedFilters = Object.keys(query.filters).map((key) => {
        return {
          dimension: replaceDimensionMiss(key),
          operator: "contains",
          values: Object.values(query.filters[key]),
        };
      });
    }
  }

  return {
    ...query,
    filters: normalizedFilters,
    dimensions: query.dimensions?.map((d) => {
      return replaceDimensionMiss(d);
    }),
  };
}

export function replaceDimensionMiss(value) {
  if (COMMON_AI_MISSES_MAP.dimensions[value]) {
    return COMMON_AI_MISSES_MAP.dimensions[value];
  }
  return value;
}

export const COMMON_AI_MISSES_MAP = {
  dimensions: {
    "Product.department_code": "Department.name",
    "Product.category_code": "Category.name",
    "Product.supplier_code": "Supplier.name",
    "Product.category": "Category.name",
    "Product.department": "Department.name",
    "Product.supplier": "Supplier.name",
    "Sale.identifier": "Sale.sale_stamp",
  },
};
